const defaultColumn = [
  {
    header: 'ID',
    accessorKey: 'id'
  },
  {
    header: 'Name',
    accessorKey: 'name'
  },
  {
    header: 'QTY',
    accessorKey: 'qty'
  },
  {
    header: 'Lunas',
    accessorKey: 'paid'
  },
  {
    header: 'Status',
    accessorKey: 'damaged'
  },
  {
    header: 'Serial Number',
    accessorKey: 'sn'
  },
  {
    header: 'Location',
    accessorKey: 'location'
  },
  {
    header: 'Price',
    accessorKey: 'price'
  },
  {
    header: 'Update  Delete',
    accessorKey: 'actions',
    enableSorting: false,
    filterable: false
  }
]

export default defaultColumn
